angular.module('vm', [
    'pascalprecht.translate',
]);

angular.module('vm.helpCenterApr21', [
    'vm',
    'vm.config',
    'vm.common',
    'pascalprecht.translate',
    'ngSanitize',
    'vcRecaptcha',
    'mgcrea.ngStrap',
])

    .config(function ($translateProvider) {
        $translateProvider.preferredLanguage('en');
    })

    .run(($injector) => {
        window.injector = $injector;
    })
;